import { FC, Suspense, useMemo, useState } from 'react';
import { ClockInSection } from './clockIn/ClockInSection';
import { RosterSection } from './roster/RosterSection';
import { useFeatures } from '@/services/backstage/useFeatures';
import { Tab, TabSelector } from '@/components/shared/TabSelector';
import { Loader } from '@/components/shared/Loader';

interface HomeContentsManagersProps {}

const CLOCK_IN_OPTION = 'clockIn';
const ROSTER_OPTION = 'roster';

export const HomeContentsManagers: FC<HomeContentsManagersProps> = () => {
  const clockInEnabled = useFeatures('clockIn');
  const rosterEnabled = useFeatures('roster');

  const tabOptions = useMemo(() => {
    const options: Tab[] = [];

    if (clockInEnabled) {
      options.push({ id: CLOCK_IN_OPTION, name: 'Clock In/Clock Out' });
    }

    if (rosterEnabled) {
      options.push({ id: ROSTER_OPTION, name: 'Rostering' });
    }

    return options;
  }, [clockInEnabled, rosterEnabled]);

  const [selectedOption, setSelectedOption] = useState<Tab | undefined>(() => {
    if (tabOptions.length === 0) {
      return undefined;
    }

    const storedVal = localStorage.getItem('selectedHomeTab');
    const storedTab = tabOptions.find(t => t.id === storedVal);

    return storedTab || tabOptions[0];
  });

  const onChange = (newTab: Tab) => {
    localStorage.setItem('selectedHomeTab', newTab.id);
    setSelectedOption(newTab);
  };

  return (
    <div className="flex flex-col gap-5 items-center">
      {tabOptions.length > 1 && selectedOption && (
        <TabSelector tabs={tabOptions} selectedTab={selectedOption} setSelectedTab={onChange} className="w-[350px]" />
      )}
      <Suspense fallback={<Loader className="h-12 w-12"></Loader>}>
        {selectedOption?.id === CLOCK_IN_OPTION && <ClockInSection />}
        {selectedOption?.id === ROSTER_OPTION && <RosterSection />}
      </Suspense>
    </div>
  );
};
